import { render, staticRenderFns } from "./SubmitRequest.vue?vue&type=template&id=12cc093d&scoped=true"
import script from "./SubmitRequest.vue?vue&type=script&lang=js"
export * from "./SubmitRequest.vue?vue&type=script&lang=js"
import style0 from "./SubmitRequest.vue?vue&type=style&index=0&id=12cc093d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc093d",
  null
  
)

export default component.exports